<template>
  <div class="home">
    <ModalBackground
      @deactivateModal="deactivateModal"
      :outerWrapperStyles="modalStyles" 
      :innerWrapperStyles="modalContentStyles" 
    >
    </ModalBackground>
    <transition name="fade">
      <Walkthrough 
        class="trans"
        v-show="walkthroughOn" 
        @exit="removeWalkthrough"
      />
    </transition>
    <ContactForm
      @exit="deactivateModal"
      @success="contactMessageSuccess"
      @error="handleError"
      v-show="showContactForm"
      :outerWrapperStyles="contactFormContainer"
      :destination="'/message'"
      :captcha="true"
      title="Contact Details"
    />
    <TextBox 
      :CtnStyles="SuccessMessageStyles"
      :innerCtnStyles="SuccessMessageInnerStyles"
      v-show="messageSuccess"
      title="Success!"
      text="Message Sent Successfully!"
      text2="We will be in contact with you soon!"
    />

    <TextBox 
      :CtnStyles="ErrorMessageStyles"
      :innerCtnStyles="ErrorMessageInnerStyles"
      v-show="messageError"
      title="Sorry, something went wrong with your request"
      text="Message was not sent successfully"
    />
    <Jumbotron 
      title="Composer Software"
    />
    <!--<Grid1x1>
      <TextRows 
        v-bind:showBack="false" 
        v-bind:showNext="false" 
        :texts="slogan">
      </TextRows>
    </Grid1x1>

    <Grid1x1
      :gridStyles="contactGridStyles">
      <button 
        class="navbtn newfont"
        @click="Redirect('about')">About</button>

    </Grid1x1>
    <Grid1x1
      :gridStyles="contactGridStyles">
      <button 
        class="navbtn newfont"
        @click="Redirect('sites')">Our Sites</button>

    </Grid1x1>
    <Grid1x1
      :gridStyles="contactGridStyles">
      <button 
        class="navbtn newfont"
        @click="activateModal">Request Contact</button>

    </Grid1x1>

    <Grid1x1
      :gridStyles="contactGridStyles">
      <button 
        class="navbtn newfont border-btm"
        @click="activateWalkthrough">Walkthrough</button>

    </Grid1x1>-->
    <!--<Footer 
      class="border-top"
      copywrite="Composer Software 2022" 
    />-->
  </div>
</template>

<script>
// @ is an alias to /src
//import Grid1x1 from '@/components/1x1grid.vue';
import Jumbotron from '@/components/Jumbotron.vue'
//import ImageBox from '@/components/ImageBox.vue';
import TextBox from '@/components/TextBox.vue';
//import TextRows from '@/components/TextRows.vue';
import ModalBackground from '@/components/ModalBackground.vue';
import ContactForm from '@/components/ContactForm.vue';
//import Footer from '@/components/Footer';
import Walkthrough from '@/views/Walkthrough';
export default {
  name: 'Home',
  components: {
    Jumbotron,
    ModalBackground,
    ContactForm,
    Walkthrough,
    TextBox
  },
  data:function(){
    return {
      slogan:["How many people that run businesses have problems with websites that run their business?"],
      modalActive:false,
      walkthroughOn:false,
      messageSuccess:false,
      messageError:false,
      showContactForm:false,
      modalStyles:{
        zIndex:-1,
        opacity:0
      },
      modalContentStyles:{
        position:"absolute",
        left:"50%",
        transform:"translateX(-50%)",
        zIndex:11
      },
      contactGridStyles:{
        width:"100vw",
        minHeight:"75px",
        border:"none"
      },
      contactFormContainer:{
        position:"absolute",
        left:"50%",
        transform:"translateX(-50%)",
        top:"15%",
        zIndex:12
      },
      SuccessMessageInnerStyles:{
        fontSize:"2em",
        color:"green"
      },
      SuccessMessageStyles:{
        zIndex:13,
        position:"absolute",
        left:"50%",
        top:"30%",
        transform:"translateX(-50%)",
        backgroundColor:"#fff"
      },
      ErrorMessageInnerStyles:{
        color:"red",
        fontSize:"2em"
      },
      ErrorMessageStyles:{
        zIndex:13,
        position:"absolute",
        left:"50%",
        top:"30%",
        transform:"translateX(-50%)",
        backgroundColor:"#fff"
      },
      catpcha1:null
    } 
  },
  methods:{
    preventTab(objEvent){
      if(objEvent.keyCode == 9) {  //tab pressed
        objEvent.preventDefault(); // stops its action
      }
    },
    activateWalkthrough(){
      this.walkthroughOn = true;
      document.addEventListener('keydown',this.preventTab);
    },
    removeWalkthrough(){
      this.walkthroughOn = false;
      document.removeEventListener('keydown',this.preventTab);
    },
    Redirect(path){
      this.$router.push({path:`/${path}`});
    },
    activateModal(){
      //document.querySelector('body').style.overflow = "hidden"
      this.modalActive = true;
      this.showContactForm = true;
      this.modalStyles = {
        position:"fixed",
        zIndex:10,
        opacity:0.8
      }
      this.renderCaptcha()
    },
    setHeight(){
      setTimeout(() => {
        let form = document.getElementById("ContactForm");
        let formHeight = form.offsetHeight;
        let windowHeight = window.innerHeight;
        let diff = windowHeight - formHeight;
        let placeoffset = Math.floor(diff/2);
        this.contactFormContainer.top = `${placeoffset}px`
        let tarea = document.getElementById("contactFormTextArea")
        if(diff <= 0){
          this.contactFormContainer.top = "2px"
          let tarea = document.getElementById("contactFormTextArea")
          tarea.style.minHeight = "100px"
        } else {
          tarea.style.minHeight = "200px"
        }
      }, 100)
    },
    deactivateModal(){
      document.querySelector('body').style.overflow = ""
      this.modalActive = false;
      this.modalStyles = {
        position:"fixed",
        zIndex:-1,
        opacity:0
      }
      this.showContactForm = false;
    },
    contactMessageSuccess(){
      ////console.log('message success')
      this.messageSuccess = true;
      this.showContactForm = false;
      setTimeout(() => {
        this.deactivateModal()
        this.messageSuccess = false;
      },4000)
    },
    handleError(){
      this.messageError = true;
      this.showContactForm = false;
      setTimeout(() => {
        this.deactivateModal()
        this.messageError = false;
      },4000);
    },
    renderCaptcha(){
      if(document.getElementById('ContactFormCaptcha').children.length === 0){
        let elId = "ContactFormCaptcha"
        let captchaOpts = {
          'sitekey':"6Ld4TNscAAAAAMLa9H3OvE5gZeP3FlDkQ8LFlQef"
        }
        window.captcha1 = window.grecaptcha.render(elId, captchaOpts);  
      } else {
        window.grecaptcha.reset(window.captcha1);
      }

      this.setHeight()
    }
  },
  computed:{
  },
  created(){

  }
}
</script>

<style scoped>
.home {
  display:grid;
}
.img-ctn {
  width:100%;
  overflow:hidden;
}
img {
  object-fit:cover;  
  width:100%;
}
.fade-leave-active {
  transition: opacity .333s;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}
.border-btm {
  border-bottom: 1px solid #767676;
}
.border-top {
  border-top: 2px solid #767676;
}
.navbtn {
  cursor:pointer;
  transition: all 0.7s ease-in-out;
  color:black;
  background-color:white;
  border-bottom:none;
  padding:.51em 2.5em;
  width:100%;
  font-size:5em;
}

.navbtn:hover {
  cursor:pointer;
  transition: all 0.7s ease-in-out;
  color:white;
  background-color:black;
}

@media only screen and (max-width: 900px) {
  .navbtn {
    padding:.31em 1em;
    font-size:3em;
  }
}
@media only screen and (max-width: 600px) {
  .navbtn {
    padding:0;
    font-size:2em;
  }
}
</style>
